import { CatHeading, CatIconSuccessFilled } from 'components/blocks-components';
import { useTranslations } from 'next-intl';
import cx from 'classnames';
import styles from './product-list-key.module.scss';

type KeyMainSectionProps = {
  isProductVariant: boolean;
};

const KeyMainSection = ({ isProductVariant }: KeyMainSectionProps) => {
  const t = useTranslations();

  return (
    <div className="d-flex mb-md-0 mb-3 gap-2 align-items-start">
      <div className={styles['product-list-key__icon-container']}>
        <CatIconSuccessFilled
          color="success"
          className="d-md-none d-block"
          data-testid="mobile-fitment-success-icon"
        />
        <CatIconSuccessFilled
          color="success"
          size="lg"
          className="d-md-flex d-none"
          data-testid="desktop-fitment-success-icon"
        />
      </div>
      <div
        className={cx(styles['product-list-key__main-section-container'], {
          [styles['full-width']]: isProductVariant,
          [styles['fixed-width']]: !isProductVariant
        })}
      >
        <CatHeading level="h6">{t('PART_FACTORY_FIT')}</CatHeading>
        <p className="cat-u-theme-typography-label-lg mt-md-2 mt-1 mb-md-3 mb-2">
          {t('FACTORY_FIT_MESSAGE')}
        </p>
        <p
          className={cx(
            'cat-u-theme-typography-body-sm mb-0',
            styles['product-list-key__main-section-container__fit-text']
          )}
        >
          {t('FACTORY_FIT_TEXT')}
        </p>
      </div>
    </div>
  );
};

export default KeyMainSection;
